var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSortingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28125 1.3125C5.65625 0.90625 6.3125 0.90625 6.6875 1.3125L10.6875 5.3125C10.9688 5.59375 11.0625 6.03125 10.9062 6.40625C10.75 6.78125 10.4062 7.03125 10 7.03125H2C1.59375 7.03125 1.21875 6.78125 1.0625 6.40625C0.90625 6.03125 1 5.59375 1.28125 5.3125L5.28125 1.3125ZM5.28125 14.7188L1.28125 10.7188C1 10.4375 0.90625 10 1.0625 9.625C1.21875 9.25 1.59375 9 2 9H10C10.375 9 10.75 9.25 10.9062 9.625C11.0625 10 10.9688 10.4375 10.6875 10.7188L6.6875 14.7188C6.3125 15.125 5.65625 15.125 5.28125 14.7188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortingIcon);
export default __webpack_public_path__ + "static/media/table_sorting_icon.de4b49e1679a955888e7d2e08c76cb31.svg";
export { ForwardRef as ReactComponent };